import { useApiAction } from "api/drops/useApiAction";
import { performPuzzelCatalogSearch } from "api/puzzel/puzzel";
import CallTransfer from "features/Header/PuzzelTelephone/components/CallControl/views/CallInSession/CallTransfer/CallTransfer";
import CallerNumberInfo from "features/Header/PuzzelTelephone/components/CallerNumberInfo";
import SessionCommand from "features/Header/PuzzelTelephone/components/SessionCommand";
import {
  IqSessionRequestType,
  IqSessionStateTypes,
  SessionCommands,
  Status,
} from "features/Header/PuzzelTelephone/components/types";
import { usePuzzelExtendedStateInformation } from "features/Header/PuzzelTelephone/provider/contexts/ListenForCallStatusContext";
import { usePuzzelAuthenticationContext } from "features/Header/PuzzelTelephone/provider/contexts/PuzzelAuthenticationContext";
import { useUserValidationState } from "features/Header/PuzzelTelephone/provider/contexts/UserValidationContext";
import {
  CallIconStyled,
  CallStatusStyled,
} from "features/Header/PuzzelTelephone/PuzzelStyle";
import {
  assembleFullName,
  NO_COUNTRY_CODE_PREFIX,
  removePhoneNumberPrefixes,
} from "features/Header/PuzzelTelephone/utils";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/typography/TitleStyles";

type Props = {
  req: IqSessionRequestType;
};

const StatusConnected = (props: Props) => {
  const { req } = props;
  const { status, remoteAddress } = req;
  const { t } = useTranslation();

  const { phoneNumberPrefix, functionalNumberPrefix } =
    usePuzzelAuthenticationContext();

  const searchString = removePhoneNumberPrefixes(remoteAddress, [
    phoneNumberPrefix,
    NO_COUNTRY_CODE_PREFIX,
    functionalNumberPrefix,
  ]);

  const puzzelUserId = useUserValidationState().userId;
  const { iqSessionState }: any = usePuzzelExtendedStateInformation();

  const ConsultationCall =
    iqSessionState === IqSessionStateTypes.ConsultationCall;
  const [callerInfo, setCallerInfo] = useState("");
  const [catalogRawResponse, performCatalogSearch] = useApiAction(
    performPuzzelCatalogSearch,
    false,
  );

  useEffect(() => {
    if (catalogRawResponse.data?.result?.length > 0) {
      const fullName = assembleFullName(catalogRawResponse.data?.result);
      setCallerInfo(fullName);
    } else {
      setCallerInfo("");
    }
  }, [catalogRawResponse]);

  useEffect(() => {
    if (status === Status.Connected) {
      performCatalogSearch({
        searchString,
        userId: puzzelUserId,
      });
    }
  }, [status]);

  if (status === Status.Connected) {
    return (
      <div style={{ display: "flex", gap: "1.5rem", alignItems: "center" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
          }}
        >
          <Text bold>{t("I samtale")}</Text>
          <CallerNumberInfo
            status={status}
            remoteAddress={`${callerInfo} ${searchString}`}
          />
        </div>
        <CallIconStyled />
        <SessionCommand
          command={
            ConsultationCall
              ? SessionCommands.ConsultOff
              : SessionCommands.Hangup
          }
          requestId={req.id}
        />
        {!ConsultationCall ? (
          <SessionCommand command={SessionCommands.MuteOn} requestId={req.id} />
        ) : null}
        {!ConsultationCall ? (
          <CallStatusStyled>
            <CallTransfer requestId={req.id} />
          </CallStatusStyled>
        ) : null}
      </div>
    );
  }
  return null;
};

export default StatusConnected;
